<template>
  <b-card>
    <b-card-header><h4 class="title">ثبت قرارداد</h4></b-card-header>
    <b-card-body>
      <contract-form
        :saving="saving"
        :server-errors="serverErrors"
        submit-label="ثبت قرارداد"
        @submit="createContract"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BCardHeader } from 'bootstrap-vue'
import ContractForm from './ContractForm.vue'

export default {
  name: 'ContractCreate',
  components: { BCard, BCardBody, BCardHeader, ContractForm },
  data() {
    return { saving: false, serverErrors: {} }
  },
  methods: {
    createContract(payload) {
      this.saving = true
      this.serverErrors = {}
      this.$http.post('contracts', payload)
        .then(({ data }) => {
          if (!data.status) throw new Error(data.message || 'ثبت قرارداد با خطا مواجه شد.')
          this.$bvToast.toast('قرارداد با موفقیت ثبت شد.', {
            title: 'موفقیت', toaster: 'b-toaster-top-right', variant: 'success',
          })
          this.$router.push({ name: 'Contract_List' })
        })
        .catch(error => this.handleError(error))
        .finally(() => { this.saving = false })
    },
    handleError(error) {
      this.serverErrors = (error.response && error.response.data && error.response.data.errors) || {}
      this.$bvToast.toast((error.response && error.response.data && error.response.data.message) || error.message, {
        title: 'خطا در ثبت قرارداد', toaster: 'b-toaster-top-right', variant: 'danger',
      })
    },
  },
}
</script>